import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import poweredByUniledLogo from 'public/poweredByUniledLogo.png';

type ReportPageProps = {
    logoUrl: string;
    brand: string;
    campaignId: number | string;
    campaignTitle: string;
    splitWidth?: string;
    children: React.ReactNode;
};

export default function DspSplitReportPage({
    logoUrl,
    brand,
    campaignId,
    campaignTitle,
    splitWidth = '58%',
    children,
}: ReportPageProps) {
    return (
        <Box
            className="page"
            sx={{
                position: 'relative',
                '--split-w': splitWidth as any,
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 0,
                    pointerEvents: 'none',
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        bottom: 0,
                        left: 0,
                        width: splitWidth,
                        bgcolor: '#f3f4f6',
                    }}
                />
            </Box>

            <Box className="page-header" sx={{ zIndex: 1 }}>
                <Stack
                    direction="row"
                    alignItems="flex-end"
                    justifyContent="flex-end"
                    sx={{ width: 1 }}
                >
                    <Box component="img" src={logoUrl} alt="Logo" className="header-logo" />
                </Stack>
            </Box>

            <Box sx={{ pt: 0, position: 'relative', zIndex: 1 }}>{children}</Box>

            <Box
                className="page-footer"
                sx={{
                    px: 2,
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 1,
                }}
            >
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ height: 'calc(var(--footer-h) - 18px)', px: 'var(--pad-x)' }}
                >
                    <Typography variant="body2" sx={{ fontWeight: 700 }}>
                        #{campaignId} | {campaignTitle}
                    </Typography>

                    <Stack direction="row" alignItems="flex-end" gap={2}>
                        <Box
                            component="img"
                            src={poweredByUniledLogo}
                            alt="Powered by UniLED"
                            sx={{ maxHeight: 32, objectFit: 'contain', display: 'block' }}
                        />
                    </Stack>
                </Stack>
                <Box
                    sx={{
                        position: 'absolute',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: 18,
                        bgcolor: brand,
                    }}
                />
            </Box>
        </Box>
    );
}
